import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AlertService, ItemToSell, ItemToSellPicture, ItemToSellSource, ItemToSellState, ItemsToSellService, UserService } from 'src/app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Money } from '@dintero/money';
import { MatChipInputEvent } from '@angular/material/chips';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Meta, Title } from '@angular/platform-browser';
import { NoPicturesConfirmationDialog } from 'src/app/modules/shared/no-pictures-dialog/components/no-pictures-dialog/no-pictures-dialog.component';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { isPlatformBrowser } from '@angular/common';

export function existingCategory(allCategories: string[]): ValidatorFn {
  
  return (control: AbstractControl) : ValidationErrors | null => {

    const value = control.value as string;

    if (!value) {
        return null;
    }
    
    return allCategories.indexOf(value.toLowerCase()) ? { categoryInvalid: true } : null;
  }
}

//TODO: avoid duplicate categories
@Component({
  selector: 'edit-listing-page',
  templateUrl: './edit-listing-page.component.html',
  styleUrls: ['./edit-listing-page.component.scss']
})
export class EditListingPageComponent extends MaterialPage implements OnInit {
  
  separatorKeysCodes: number[] = [ENTER, COMMA];
  //allCategories: string[] = ['apple', 'lemon', 'lime', 'orange', 'strawberry'];
  
  allTopLevelCategories = ["Fashion & Accessories", "Home & Furniture", "Food & Kitchen", "Health", "Electronics", "Kids", "Books", "Car related", "Other"];
  
  //filteredCategories: Observable<string[]>;
  itemToSell: ItemToSell | undefined;
  itemToSellId: 'local' | 'new' | number | undefined;
  isCreatePage = false;
  pictures: ItemToSellPicture[] = [];
  pageReady = false;
  nextPage: string | undefined;
  flow: string = "/";
  
  listingForm = new FormGroup({
    title: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(255)]),
    description: new FormControl('', [Validators.maxLength(1000)]),
    condition: new FormControl('', [Validators.required]),
    price: new FormControl(0, [Validators.required, Validators.min(0)]),
    picturesLength: new FormControl(0, []),
    purchasedInShop: new FormControl('', [Validators.maxLength(100)]),
    dateOfPurchase: new FormControl(null as null | Date | undefined, []),
    topLevelCategory: new FormControl('', []),
    categories: new FormControl([] as string[], []),
  });
  
  @ViewChild('listingFormElement') listingFormElement!: NgForm;
  
  //category = new FormControl('', [Validators.required, existingCategory(this.allCategories)]);
  
  //@ViewChild('categoryInput') categoryInput: ElementRef<HTMLInputElement>;

  constructor(
    breakpointObserver: BreakpointObserver,
    private itemsToSellService: ItemsToSellService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private dialog: MatDialog,
    private router: Router,
    titleService: Title,
    sidenavService: SidenavService,
    @Inject(PLATFORM_ID) private platformId: any,
    meta: Meta) {
      
    super(breakpointObserver, titleService, meta, sidenavService, router, $localize `:page title:Edit listing`, '', true);
    /*this.filteredCategories = this.category.valueChanges.pipe(
      startWith(null),
      map((category: string | null) => (category ? this._filter(category) : this.notSelectedCategories.slice())),
    );*/
  }
  
  async ngOnInit() {
    
    this.saveBeginningOfFlow();
    
    // First get the product id from the current route.
    const routeParams = this.route.snapshot.paramMap;
    
    const id = routeParams.get('id');
    this.nextPage = routeParams.get('nextPage') || undefined;
    
    if (id === "new") {
      this.isCreatePage = true;
      this.itemToSellId = 'new';
    } else if (id === 'local') {
      
      const itemToSell = this.itemsToSellService.getLocalItem();
      
      if (!itemToSell) {
        console.log("local item missing");
      }
      
      this.itemToSell = itemToSell!;
      this.pictures = this.itemToSell.pictures;
      this.itemToSellId = 'local';
      this.initForm(this.itemToSell);
    } else {
      this.itemToSellId = +id!;
  
      // Find the product that correspond with the id provided in route.
      this.itemToSell = (await this.itemsToSellService.find(this.itemToSellId))!;
      this.pictures = this.itemToSell.pictures;
      this.initForm(this.itemToSell);
    }
    
    this.pageReady = true;
  }
  
  private saveBeginningOfFlow() {
    if (isPlatformBrowser(this.platformId)) {
      this.flow = history.state.flow;
    }
  }
  
  private initForm(itemToSell: ItemToSell) {
    this.listingForm.controls["title"].setValue(itemToSell.originalTitle!);
    this.listingForm.controls["description"].setValue(itemToSell.originalDescription!);
    this.listingForm.controls["condition"].setValue(itemToSell.condition ? itemToSell.condition.toString() : "");
    this.listingForm.controls["price"].setValue(itemToSell.priceEUR!.toNumber());
    this.listingForm.controls["picturesLength"].setValue(itemToSell.pictures.length);
    this.listingForm.controls["purchasedInShop"].setValue(itemToSell.purchasedInShop || '');
    this.listingForm.controls["dateOfPurchase"].setValue(itemToSell.dateOfPurchase);
    this.listingForm.controls["topLevelCategory"].setValue(itemToSell.topLevelCategory);
    this.listingForm.controls["categories"].setValue(itemToSell.lowestLevelCategories);
  }
  
  get selectedCategories(): string[] {
    return this.listingForm.controls["categories"].value!;
  }
  
  removeCategory(category: string): void {
    const index = this.selectedCategories.indexOf(category);

    if (index >= 0) {
      this.selectedCategories.splice(index, 1);
    }
    
    this.listingForm.controls["categories"].updateValueAndValidity()
  }
  
  addCategory(event: MatChipInputEvent): void {
    
     const value = (event.value || '').trim();

    if (value) {
      this.selectedCategories.push(value);
    }

    event.chipInput!.clear();
    
    this.listingForm.controls["categories"].updateValueAndValidity();
  }
  
  /*
  selected(event: MatAutocompleteSelectedEvent): void {
    this.addCategoryToControl(this.category.value!);
    this.categoryInput.nativeElement.value = '';
    this.category.setValue(null);
  }
  
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    
    if (this.category.invalid) {
      return;
    }

    this.addCategoryToControl(value);

    // Clear the input value
    event.chipInput!.clear();

    this.category.setValue(null);
  }
  
  private addCategoryToControl(value: string) {
    if (value) {
      (this.listingForm.controls['categories'].value as string[]).push(value);
      this.listingForm.controls['categories'].updateValueAndValidity();
    }
  }
  
  private removeCategoryFromControl(value: string) {
    
    const index = (this.listingForm.controls['categories'].value as string[]).indexOf(value);
    
    if (index >= 0) {
      (this.listingForm.controls['categories'].value as string[]).splice(index, 1);
      this.listingForm.controls['categories'].updateValueAndValidity();
    }
  }

  remove(category: any): void {
    this.removeCategoryFromControl(category);
  }*/
  
  public numberOfPicturesChanged() {
    this.listingForm.controls["picturesLength"].setValue(this.pictures.length);
  }
  
  async createListing() {

    if (this.listingForm.invalid) {
      console.log("Invalid form");
      console.log(this.listingForm.controls["categories"].value)
      this.getFormValidationErrors();
      this.alertService.showError($localize `Please correct errors before proceeding`);
      return;
    }
    
    if (+this.listingForm.controls["picturesLength"].value! === 0) {
      const dialogRef = this.dialog.open(NoPicturesConfirmationDialog, {
        data: { itemToSellId: this.itemToSellId }
      });

      const result = await firstValueFrom(dialogRef.afterClosed());
      
      if (!result) {
        console.log("No confirmation received");
        return;
      }
    }
    
    this.listingForm.disable();
    
    await this.itemsToSellService.create({
      title: this.listingForm.controls["title"].value!,
      description: this.listingForm.controls["description"].value,
      dateOfPurchase: this.listingForm.controls["dateOfPurchase"].value?.toISOString().split('T')[0],
      price: {
        amount: this.listingForm.controls["price"].value!,
        currency: "EUR"
      },
      purchasedInShop: this.listingForm.controls["purchasedInShop"].value!,
      condition: +this.listingForm.controls["condition"].value!,
      categories: this.listingForm.controls["categories"].value!,
      pictures: this.pictures,
      state: ItemToSellState.LISTED,
      source: ItemToSellSource.MANUAL
    });
    
    this.alertService.showSuccess($localize `Listing created successfully`);
    this.listingFormElement.resetForm();
    this.listingForm.enable();
  }
  
  async updateListing() {
    
    if (!this.itemToSell) {
      return;
    }

    const formValue = this.listingForm.getRawValue();
        
    if (!this.listingForm.valid) {
      console.log("Invalid form");
      this.alertService.showError($localize `Please correct errors before proceeding`);
      return;
    }
    
    if (+formValue.picturesLength! === 0) {
      const dialogRef = this.dialog.open(NoPicturesConfirmationDialog, {
        data: { itemToSellId: this.itemToSellId }
      });

      const result = await firstValueFrom(dialogRef.afterClosed());
      
      if (!result) {
        console.log("No confirmation received");
        return;
      }
    }
    
    console.log("Updating listing...." + JSON.stringify(formValue));
    this.applyFormToItem(this.itemToSell, formValue);
    
    try {
      if (this.itemToSellId === 'local') {
        this.itemsToSellService.persistLocally(this.itemToSell);
      } else {
        await this.itemsToSellService.updateAsync(this.itemToSell);
      }
    } catch (e) {
      this.alertService.showError($localize `Error updating listing`);
      return;
    }
    
    if (this.itemToSell.state === ItemToSellState.LISTED) {
      this.alertService.showSuccess($localize `Listing updated successfully`);
    }
    
    this.navigateToNextPage("/view-listing/" + this.itemToSellId);
  }
  
  private navigateToNextPage(fallback: string) {
    
    if (!this.nextPage) {
      this.router.navigate([fallback], { state: { flow: this.flow }});
      return;
    }
    
    this.router.navigate([this.nextPage], { state: { flow: this.flow }});
  }
  
  async removeListing() {
    
    if (!this.itemToSell) {
      return;
    }
    
    try {
      console.log("Removing listing");
      this.itemToSell.state = ItemToSellState.READY_FOR_LISTING;
      await this.itemsToSellService.updateAsync(this.itemToSell);
    } catch (e) {
      this.alertService.showError($localize `Error removing listing`);
      return;
    }
    
    this.alertService.showSuccess($localize `Listing removed successfully`);
    this.router.navigate(["/items-to-sell"]);
  }
  
  async preview(id: number) {
    
    if (!this.itemToSell) {
      return;
    }
    
    const formValue = this.listingForm.getRawValue();
    
    if (!this.listingForm.valid) {
      console.log("Invalid form");
      this.listingForm.markAllAsTouched();
      this.alertService.showError($localize `Please correct errors before proceeding`);
      return;
    }
    
    this.applyFormToItem(this.itemToSell, formValue);
    
    try {
      await this.itemsToSellService.updateAsync(this.itemToSell);
    } catch (e) {
      this.alertService.showError($localize `Issue with updating listing`);
      return;
    }
    
    this.router.navigate([`/view-listing/${id}`], { state: { flow: this.flow }});
  }
  
    /*  dateOfPurchase: formatISO(this.listingForm.controls["dateOfPurchase"].value!),
      price: {
        amount: this.listingForm.controls["price"].value!,
        currency: "EUR"
      },
      purchasedInShop: this.listingForm.controls["purchasedInShop"].value!,
      condition: +this.listingForm.controls["condition"].value!,
      categories: this.listingForm.controls["categories"].value!*/
  
  private applyFormToItem(itemToSell: ItemToSell, formValue: { title: string | null; description: string | null; condition: string | null; price: number | null; picturesLength: number | null; purchasedInShop: string | null; dateOfPurchase: Date | null | undefined; topLevelCategory: string | null; categories: string[] | null; }) {
    
    itemToSell.title = formValue.title!;
    itemToSell.originalTitle = itemToSell.title;
    itemToSell.description = formValue.description!;
    itemToSell.originalDescription = itemToSell.description;
    itemToSell.condition = +formValue.condition!;
    itemToSell.price = Money.of(formValue.price!, "EUR");
  }
  /*
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.notSelectedCategories.filter(category => category.toLowerCase().includes(filterValue));
  }
  
  get notSelectedCategories(): string[] {
    return this.allCategories.filter(category => (this.listingForm.controls['categories'].value as string[]).indexOf(category) < 0);
  }*/
  
  public isListed(): boolean {
    
    if (!this.itemToSell) {
      return false;
    }
    
    return this.itemToSell.state === ItemToSellState.LISTED;
  }
  
  public isReadyForListing(): boolean {
    
    if (!this.itemToSell) {
      return false;
    }
    
    return this.itemToSell.state === ItemToSellState.READY_FOR_LISTING;
  }

  public toItemList() {
    this.router.navigate(["/items-to-sell"]);
  }

  public toPreview() {
    this.navigateToNextPage("/view-listing/" + this.itemToSellId);
  }
  
  get analyticsCategory() {
    return this.isCreatePage ? 'new' : this.itemToSellId;
  }
  
  getFormValidationErrors() {
    Object.keys(this.listingForm.controls).forEach(key => {
      const controlErrors: ValidationErrors | null = this.listingForm.get(key)!.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
         console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }
}
